/**
 * Created by marccurry on 2/25/16.
 */
'use strict';
(function($) {

    /**
     *
     * The homepage news slider
     *
     * */

    $('.image-slider').slick({
        infinite: true,
        dots: true,
        arrows: true,
        slide:'.slide',
        prevArrow : $('.slider-arrow.left'),
        nextArrow: $('.slider-arrow.right'),
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        fade: true,
        cssEase: 'linear'

    }).show();

})( jQuery );

